/*
 * @Descripttion:
 * @Author: 苍狼一啸八荒惊
 * @Date: 2024-09-05 10:48:47
 * @LastEditTime: 2025-09-04 16:02:15
 * @LastEditors: sudo_rm_rf
 */
import axios from 'axios';
import router from '/@/router';
import { globalData } from '/@/setting/global';
import { getCookie, setCookie, removeCookie } from '/@/utils/cookie';
import { useUser } from '/@/store/index';
import { ElMessageBox } from 'element-plus';
axios.defaults.headers['Content-Type'] = 'application/json';
axios.defaults.withCredentials = true;

let config = {
  baseURL: globalData.apiUrl,
  timeout: 10 * 60 * 1000,
  withCredentials: true,
  Headers: {
    'Content-Type': 'application/json',
  },
};
// 是否显示重新登录
let isRelogin = { show: false };
const http = axios.create(config);

http.interceptors.request.use(
  (config) => {
    const token = getCookie('TOKEN');
    const clientId = getCookie('clientId');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.clientId = `${clientId}`;
      config.headers['Content-Type'] = 'application/json';
      config.headers.language = JSON.parse(localStorage.getItem('common') || '{ "locale": "zh_CN" }').locale;
    }
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  },
);

// Add a response interceptor
http.interceptors.response.use(
  (response) => {
    // Do something with response data
    // console.log("响应数据: ", response);
    if (response.data?.code === 403 || response.data?.code === 401) {
      // TOKEN 过期
      // useUser().setRoles([]);
      // removeCookie('TOKEN');
      // localStorage.removeItem('userName');
      // router.push('/login');
      if (!isRelogin.show) {
        isRelogin.show = true;
        ElMessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            useUser().setRoles([]);
            removeCookie('clientId');
            removeCookie('TOKEN');
            localStorage.removeItem('userName');
            // location.href = '/login';
            // router.push('/login');
            location.href = '/hostComputer/#/login';
            location.reload();
          })
          .finally(() => {
            isRelogin.show = false;
          });
      }
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。');
    } else if (response.data?.code === 405) {
      message.error(response.data.msg);
      return;
    }
    return response.data;
    if (response.data?.code === 200) {
      return response.data;
    } else {
      if (response.config.responseType && response.config.responseType == 'blob') {
        return response.data;
      } else {
        message.error(response.data?.message || '请求错误');
        return Promise.reject(response);
      }
    }
  },
  (error) => {
    console.log(error.response);
    if (error.message.includes('timeout')) {
      message.error('任务执行时间过长');
    } else if (error.response?.status === 401) {
      useUser().setRoles([]);
      removeCookie('TOKEN');
      localStorage.removeItem('userName');
      router.push('/login');
    } else if (error.response?.status === 500) {
      message.error(error.response?.data?.message || '服务器错误');
    } else if (error.response?.status === 502) {
      // removeCookie('TOKEN');
      // localStorage.removeItem('userName');
      router.push('/login');
    }
    // Do something with response error
    return Promise.reject(error.response);
  },
);

export default http;
